// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"353":"12cd286c","439":"16e1f83f","787":"e8a073cc"}[chunkId] + ".chunk.js";
};